import { NotificationProgrammatic as Notification } from 'buefy';
export default class VueUtilities {
    static openErrorToast = function (message) {
        Notification.open({
            message: message,
            duration: 4000,
            closable: true,
            position: 'is-bottom-right',
            type: 'is-danger',
            hasIcon: true,
            queue: false,
            autoClose: true
        });
    };
    static openSuccessToast = function (message) {
        Notification.open({
            message: message,
            duration: 2000,
            closable: true,
            position: 'is-bottom-right',
            type: 'is-success',
            hasIcon: true,
            queue: false,
            autoClose: true
        });
    };
}
